import { styled } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

export const Container = styled('span')(() => ({
  position: 'relative',
  marginLeft: 12,
  '& .MuiPaper-root': {
    marginTop: 12,
  },
}));

export const Icon = styled(InfoOutlined)(({ theme }) => ({
  color: theme.palette.action.active,
  cursor: 'pointer',
}));
